import { render, staticRenderFns } from "./pageAdd.vue?vue&type=template&id=797930b0&"
import script from "./pageAdd.vue?vue&type=script&lang=ts&"
export * from "./pageAdd.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports